import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { passwordValidator } from '@core/validators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css']
})
export class DeleteAccountComponent implements OnInit {

  public passwordControl: FormControl = new FormControl('', [
    Validators.required,
    passwordValidator
  ]);
  public controlSubmitAttempt: boolean = false;


  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

  deleteAccount(): void {
    this.controlSubmitAttempt = true;
    if ( this.passwordControl.valid ) {
      this.activeModal.close(this.passwordControl.value);
    }
  }

}
